export class NoContextProvidedError extends Error {
  constructor(contextName: string) {
    super(`${contextName} must be provided before using it.`);
  }
}
